import axiosInstance from "./axiosInstance";

const PersonalDataProtectionAPI = {
    getDetailPersonalDataProtection: () => {
        try {
            return axiosInstance.get("contactpersonal.json");
        } catch (error) {
            console.error("ContactAPI.getDetailPersonalDataProtection", error);
            return null;
        }
    },
    getDetailPersonalDataProtectionEn: () => {
        try {
            return axiosInstance.get("en/contactpersonal.json");
        } catch (error) {
            console.error("ContactAPI.getDetailPersonalDataProtection", error);
            return null;
        }
    },

};

export default PersonalDataProtectionAPI;
